module.exports = __webpack_public_path__ + "static/media/view attendance.54f3d014.svg";